import api from 'services/api/microfwk';
import _ from 'lodash';

export const getRentHistory = (params = {}) =>
  api
    .get('/services/payway/renthistory', {
      params,
    })
    .then(({ data }) => {
      const status = _.get(data, 'status', _.get(data, 'response.status', 0));
      if (parseInt(status, 10) !== 0) {
        const error = _.get(data, 'response', data);
        return error !== null ? error : data;
      }
      return data.response;
    })
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) {
        return data;
      }
      throw error;
    });
